(async () => {
  'use strict';
  const gate = document.getElementById('ae-global-entry-gate');
  if (!gate) return;
  const url = new URL(window.location.href);
  const hashArgs = new URLSearchParams(url.hash.startsWith('#') ? url.hash.slice(1) : '');
  const force = url.searchParams.get('ae_entry') === '1' || hashArgs.get('ae_entry') === '1';
  let choice = gate.dataset.choice;
  if (force) {
    try {
      const cartUrl = gate.dataset.cartUrl || '/cart';
      await fetch(cartUrl.replace(/\/$/, '') + '/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({attributes: {ae_shopping_mode: ''}})
      });
    } catch (_) {}
    choice = '';
    gate.dataset.choice = '';
    try { window.sessionStorage.removeItem('ae_global_entry_choice'); } catch (_) {}
  }
  const explicitEnglish = /^\/en(?:-[a-z]{2})?(\/|$)/i.test(url.pathname);
  // V26: retained by the authenticated preview context across Shopify redirects.
  const qaCountry = window.AEPreviewContext?.inPreview ? window.AEPreviewContext.country : '';
  let visitorCountry = gate.dataset.country;
  const authRoute = /^\/(customer_authentication|account)(\/|$)/.test(url.pathname);
  if (qaCountry) {
    visitorCountry = qaCountry;
  } else if (gate.dataset.designMode !== 'true' && !authRoute) {
    // The previous V23 skipped geolocation on all /en/ pages and while in
    // wholesale mode, which could leave an international buyer in the TR market.
    try {
      const cachedCountry = window.sessionStorage.getItem('ae_detected_country');
      if (/^[A-Z]{2}$/.test(cachedCountry || '')) visitorCountry = cachedCountry;
      else {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
          credentials: 'same-origin', signal: AbortSignal.timeout(4000)
        });
        if (response.ok) {
          const result = await response.json();
          const country = (result.detected_values?.country?.handle || '').toUpperCase();
          if (/^[A-Z]{2}$/.test(country)) {
            visitorCountry = country;
            window.sessionStorage.setItem('ae_detected_country', country);
          }
        }
      }
    } catch (_) {}
  }
  const international = visitorCountry && visitorCountry !== 'TR';
  let selectedLocale = '';
  try { selectedLocale = sessionStorage.getItem('ae_selected_locale') || ''; } catch (_) {}
  const explicitLocale = url.pathname.match(/^\/(en|de|it|fr)(?:-[a-z]{2})?(?:\/|$)/i)?.[1]?.toLowerCase();
  const desiredLocale = explicitLocale || (/^(tr|en|de|it|fr)$/.test(selectedLocale) ? selectedLocale : (explicitEnglish || international || choice === 'wholesale' || gate.dataset.b2b === 'true' ? 'en' : 'tr'));
  // Never derive a currency from language alone; pick a Shopify Market country.
  // Respect any already selected foreign market, even if geolocation differs.
  let desiredCountry = gate.dataset.country;
  if (gate.dataset.b2b !== 'true') {
    if (qaCountry) desiredCountry = qaCountry;
    else if (gate.dataset.country === 'TR' && international) desiredCountry = visitorCountry;
  }
  const marketLanguageForm = document.querySelector('form input[name="language_code"][value="' + desiredLocale + '"]')?.form;
  const localizationKey = 'ae_localization_attempt_' + String(window.AEThemeRuntime?.id || '') + '_' + desiredCountry + '_' + desiredLocale;
  let localizationAttempted = false;
  try {
    if (gate.dataset.locale === desiredLocale && gate.dataset.country === desiredCountry) {
      sessionStorage.removeItem(localizationKey);
    } else {
      localizationAttempted = sessionStorage.getItem(localizationKey) === '1';
    }
  } catch (_) {}
  if ((gate.dataset.locale !== desiredLocale || gate.dataset.country !== desiredCountry) && !localizationAttempted && gate.dataset.designMode !== 'true' && marketLanguageForm && !/^\/(customer_authentication|account)(\/|$)/.test(url.pathname)) {
    let returnInput = marketLanguageForm.querySelector('[name="return_to"]');
    if (!returnInput) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      marketLanguageForm.appendChild(returnInput);
    }
    const returnPath = desiredLocale === 'tr' ? url.pathname.replace(/^\/(en|de|it|fr)(?:-[a-z]{2})?(?=\/|$)/i, '') || '/' : url.pathname;
    const returnUrl = window.AEPreviewContext?.withPreviewContext(returnPath + url.search + url.hash) || new URL(returnPath + url.search + url.hash, location.origin);
    returnInput.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
    if (gate.dataset.country !== desiredCountry) {
      let countryInput = marketLanguageForm.querySelector('[name="country_code"]');
      if (!countryInput) {
        countryInput = document.createElement('input');
        countryInput.type = 'hidden';
        countryInput.name = 'country_code';
        marketLanguageForm.appendChild(countryInput);
      }
      countryInput.value = desiredCountry;
    }
    try { sessionStorage.setItem(localizationKey, '1'); } catch (_) {}
    marketLanguageForm.submit();
    return;
  }
  if (gate.dataset.skip === 'true' || (!force && (choice === 'retail' || choice === 'wholesale'))) {
    gate.remove();
    return;
  }
  gate.style.display = 'flex';
  Array.from(document.body.children).forEach(element => {
    if (element !== gate) element.inert = true;
  });
  const overflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  let saving = false;
  const controls = Array.from(gate.querySelectorAll('.ae-entry-hotspot'));
  controls[0]?.focus();
  gate.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    event.preventDefault();
    const current = controls.indexOf(document.activeElement);
    const next = (current + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
    controls[next]?.focus();
  });
  const error = gate.querySelector('.ae-entry-error');

  async function choose(mode, target) {
    if (saving) return;
    saving = true;
    gate.setAttribute('aria-busy', 'true');
    controls.forEach(control => {
      control.setAttribute('aria-disabled', 'true');
      if (control.tagName === 'BUTTON') control.disabled = true;
    });
    if (error) error.hidden = true;
    try {
      const cartUrl = gate.dataset.cartUrl || '/cart';
      const response = await fetch(cartUrl.replace(/\/$/, '') + '/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({attributes: {ae_shopping_mode: mode}})
      });
      if (!response.ok) throw new Error('choice-save-failed');
      const cart = await response.json();
      if (cart.attributes?.ae_shopping_mode !== mode) throw new Error('choice-not-saved');
      try {window.sessionStorage.setItem('ae_global_entry_choice', mode);} catch (_) {}
      document.body.style.overflow = overflow;
      const destination = new URL(target || window.location.href, window.location.origin);
      if (mode === 'retail' && /\/pages\/wholesale\/?$/i.test(destination.pathname)) {
        destination.pathname = window.Shopify?.routes?.root || '/';
      }
      destination.searchParams.delete('ae_entry');
      const preserved = window.AEPreviewContext?.withPreviewContext(destination.href);
      if (preserved) { destination.search = preserved.search; destination.hash = preserved.hash; }
      const languageForm = document.querySelector('form input[name="language_code"][value="' + desiredLocale + '"]')?.form;
      if (mode === 'wholesale' && languageForm) {
        const returnInput = languageForm.querySelector('[name="return_to"]');
        if (returnInput) returnInput.value = destination.pathname + destination.search;
        const testCountry = window.AEPreviewContext?.country;
        if (testCountry && languageForm.querySelector('[name=country_code]')) languageForm.querySelector('[name=country_code]').value = testCountry;
        languageForm.submit();
      } else {
        window.location.assign(destination.href);
      }
    } catch (_) {
      saving = false;
      gate.removeAttribute('aria-busy');
      controls.forEach(control => {
        control.removeAttribute('aria-disabled');
        if (control.tagName === 'BUTTON') control.disabled = false;
      });
      if (error) {
        error.textContent = gate.dataset.saveError;
        error.hidden = false;
      }
    }
  }

  gate.querySelector('.ae-entry-retail')?.addEventListener('click', () => choose('retail'));
  gate.querySelector('.ae-entry-wholesale')?.addEventListener('click', event => {
    event.preventDefault();
    choose('wholesale', event.currentTarget.href);
  });
})();
